import { errorToast } from "@design-system/components/toast";
import { EditProfilePage } from "@framework/account/pages/EditProfilePage";
import { useNavigate } from "@remix-run/react";
import { useEffect, useRef } from "react";

type LessonCompleteProfilePageProps = {
  message: string;
};

export function LessonCompleteProfilePage({
  message,
}: LessonCompleteProfilePageProps) {
  const navigate = useNavigate();
  const displayMessage = useRef(false);

  useEffect(() => {
    if (!message) return;
    if (displayMessage.current) return;

    errorToast(message, {
      duration: 5_000,
      position: "top-center",
    });

    displayMessage.current = true;
  }, [message]);

  return (
    <div className="container mx-auto px-4 py-8">
      <EditProfilePage onSave={() => navigate(0)} />
    </div>
  );
}
